// src/components/home/HeroSection.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HeroSection.css';

const HeroSection = () => {
  const navigate = useNavigate();

  const handleStartTrial = (e) => {
    e.preventDefault();
    navigate('/register');
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-badge">
          🎉 Open Dental Integration • 14-Day Trial • HIPAA Compliant
        </div>

        <h1 className="hero-headline">
          Let Your Patients Book Appointments Online 24/7
        </h1>

        <p className="hero-subheadline">
          BookDentist.pro syncs instantly with Open Dental—no software to install, no Chrome extensions on every computer, no IT hassles. Your patients book online, it appears in Open Dental immediately. Simple.
        </p>

        <div className="hero-features">
          <div className="hero-feature">
            <div className="hero-feature-icon">📱</div>
            <div className="hero-feature-text">Patients book appointments anytime from their phone</div>
          </div>
          <div className="hero-feature">
            <div className="hero-feature-icon">⚡</div>
            <div className="hero-feature-text">Appears in Open Dental instantly—no delays</div>
          </div>
          <div className="hero-feature">
            <div className="hero-feature-icon">✓</div>
            <div className="hero-feature-text">No software installation, Chrome extensions, or IT needed</div>
          </div>
        </div>

        <div className="hero-cta">
          <button onClick={handleStartTrial} className="btn-primary">Start 14-Day Trial</button>
          <a href="/dentistjunobeach" className="btn-secondary">See Live Demo</a>
        </div>

        <p className="hero-trust">
          14-day trial • $197/month after trial • HIPAA compliant
        </p>
      </div>
    </section>
  );
};

export default HeroSection;